import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { GlassCard, GradButton } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { Th, BosDurum } from "@/components/ortak/Liste";
import api, { errMsg } from "@/lib/api";

export const EslesenUrunler = ({ cariId, yazabilir }) => {
  const [list, setList] = useState([]);
  const [urunler, setUrunler] = useState([]);
  const [f, setF] = useState({ fatura_urun_adi: "", urun_id: "" });
  const load = useCallback(() => api.get(`/cariler/${cariId}/urun-eslesmeleri`).then((r) => setList(r.data)).catch((e) => toast.error(errMsg(e))), [cariId]);
  useEffect(() => { load(); if (yazabilir) api.get("/urunler").then((r) => setUrunler(r.data.map((u) => ({ value: u.id, label: `${u.kod} · ${u.ad}` })))).catch(() => {}); }, [load, yazabilir]);
  const ekle = async () => {
    try { await api.post(`/cariler/${cariId}/urun-eslesmeleri`, f); setF({ fatura_urun_adi: "", urun_id: "" }); toast.success("Eşleştirme kaydedildi"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const sil = async (id) => { try { await api.delete(`/cariler/${cariId}/urun-eslesmeleri/${id}`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <GlassCard className="p-4 space-y-4" data-testid="cari-eslesen-urunler">
      <p className="text-xs text-muted-foreground">Bu carinin faturalarında geçen ürün adını kendi stok kartınızla eşleştirin. Liste bu cari için saklanır; gelen e-faturalar bağlandığında ürünler bu eşleştirmeyle tanınacak.</p>
      {yazabilir && <div className="grid md:grid-cols-[1fr_1fr_auto] gap-2 items-center">
        <Input data-testid="eslesme-fatura-adi" value={f.fatura_urun_adi} onChange={(e) => setF({ ...f, fatura_urun_adi: e.target.value })} placeholder="Faturadaki ürün adı" className="bg-white/5" />
        <SelectBox testid="eslesme-urun" value={f.urun_id} onChange={(v) => setF({ ...f, urun_id: v })} options={urunler} placeholder="Eşlenen ürün" />
        <GradButton data-testid="eslesme-ekle" disabled={!f.fatura_urun_adi.trim() || !f.urun_id} onClick={ekle}><Plus className="w-4 h-4" />Ekle</GradButton>
      </div>}
      {!list.length ? <BosDurum testid="eslesme-bos" /> : <table className="w-full text-sm" data-testid="eslesme-tablo">
        <thead><tr><Th>Faturadaki Ürün Adı</Th><Th>Eşlenen Ürün</Th><Th className="w-16">İşlemler</Th></tr></thead>
        <tbody>{list.map((x) => <tr key={x.id} className="border-t border-white/5" data-testid={`eslesme-${x.id}`}>
          <td className="p-2.5 text-xs">{x.fatura_urun_adi}</td><td className="p-2.5 text-xs"><span className="font-mono text-muted-foreground mr-2">{x.urun_kod}</span>{x.urun_ad}</td>
          <td className="p-2.5 text-center">{yazabilir && <button onClick={() => sil(x.id)} data-testid={`eslesme-sil-${x.id}`} className="p-1 text-muted-foreground hover:text-red-300"><Trash2 className="w-4 h-4" /></button>}</td>
        </tr>)}</tbody>
      </table>}
    </GlassCard>
  );
};
